import React, { useState } from 'react';
import type { FC, ReactNode } from 'react';
import { match } from 'variant';
import { ConfirmInput, Text, useAsync, useExit } from '@wix/cli-ui-kit';
import { readUserConfig, updateUserConfig } from '@wix/cli-user-config';

interface Props {
  children: ReactNode;
  required: boolean;
}

export const TunnelingConsent: FC<Props> = ({ required, children }) => {
  const exit = useExit();
  const [approved, setApproved] = useState<boolean>();

  const { status } = useAsync(async () => {
    const config = await readUserConfig();

    if (config.tunneling) {
      setApproved(true);
    }

    return config;
  }, []);

  if (!required || approved) {
    return children;
  }

  return (
    <>
      {match(status, {
        Success: () => (
          <ConfirmInput
            label={
              "To proceed, we'll set up a secure tunnel from your machine for development purposes"
            }
            initialValue={true}
            onSubmit={async (approved) => {
              setApproved(approved);
              await updateUserConfig({ tunneling: approved });
              if (!approved) {
                exit();
              }
            }}
          />
        ),
        Error: () => null,
        Loading: () => null,
      })}
      {approved === false && (
        <Text skin="error">
          Operation aborted. Tunneling is necessary to run your application.
        </Text>
      )}
    </>
  );
};
